export function getThemeState() {
  const { state } = this
  const themeState = state.key ? state : state.parent
  return themeState.key ? themeState : themeState.parent
}

export function getProjectThemeValues(forcedTheme, globalTheme) {
  const { state } = this
  const sceneTheme = globalTheme || this.call('getGlobalTheme')
  const themeState = state.key ? state : state.parent.key ? state.parent : null
  if (!themeState) {
    return this.warn('Theme not found', themeState)
  }
  const themeScope =
    (forcedTheme || themeState.value || themeState)[`@${sceneTheme}`] || {}
  const { color, background, borderColor, outlineColor, ...rest } = themeScope
  return { color, background, borderColor, outlineColor, ...rest }
}

export function findColorReference(FACTORY, value) {
  const globalTheme = this.call('getGlobalTheme')
  if (!value || !this.call('isString', value)) {
    return this.error(`Problem with ${value}`)
  }
  const [colorValue] = value.split(' ')
  let color = FACTORY[colorValue]
  if (globalTheme && this.call('isObject', color)) {
    color = color[`@${globalTheme}`]
  }
  if (color && color.slice(0, 2) === '--') {
    color = this.call('findColorReference', FACTORY, color.slice(2))
  }
  return color
}

export function getColorReference(value) {
  return this.call('findColorReference', this.getDesignSystem('color'), value)
}

export function getGradientReference(value) {
  return this.call(
    'findColorReference',
    this.getDesignSystem('gradient'),
    value
  )
}

export function getProjectColorByValue(value) {
  if (!value) {
    return
  }
  const color = this.call('getColorReference', value)
  if (color && typeof color === 'string') {
    const [colorValue, opacity] = color.split(' ')

    const colorArr = this.call('colorStringToRgbaArray', colorValue)
    const [r, g, b] = colorArr
    return `rgba(${r}, ${g}, ${b}, ${opacity || 1})`
  }
  const gradient = this.call('getGradientReference', value)
  return gradient
}

export function getProjectColorsFactory() {
  return (key) => this.call('getProjectColorByValue', key)
}

export function getProjectThemeColors(forcedTheme, sceneTheme) {
  const { color, background, borderColor, outlineColor, ...rest } = this.call(
    'getProjectThemeValues',
    forcedTheme,
    sceneTheme
  )

  const getFromColorFactory = this.call('getProjectColorsFactory')

  return {
    color: getFromColorFactory(color),
    background: getFromColorFactory(background),
    borderColor: getFromColorFactory(borderColor),
    outlineColor: getFromColorFactory(outlineColor),
    ...rest
  }
}

export function getActiveThemeValue(themeKey) {
  const { sceneTheme } = this.getRootState()
  const { theme: THEME } = this.getDesignSystem()
  if (!themeKey) {
     
    themeKey = this.call('getThemeState').themeKey
  }
  const themeFromData = sceneTheme
    ? THEME[themeKey][`@${sceneTheme}`]
    : THEME[themeKey]
  return themeFromData
}

export async function setThemeValueInProject(themeKey, key, val, options) {
  const { sceneTheme } = this.getRootState()
  const value = { [key]: val }
  const THEME = {
    [themeKey]: sceneTheme
      ? {
          [`@${sceneTheme}`]: value
        }
      : value
  }
  await this.updateDesignSystem({ theme: THEME }, options)
}
